interface Props {
  percent: number | null | undefined;
}

export function JobProgressBar({ percent }: Props) {
  const value = percent ?? 0;
  return (
    <div className="progress progress-striped active">
      <div
        className="progress-bar"
        role="progressbar"
        aria-valuenow={value}
        aria-valuemin={0}
        aria-valuemax={100}
        // Keep a sliver of bar visible at low percentages so a just-started job
        // doesn't look identical to one that hasn't been picked up at all.
        style={{ width: `${Math.max(value, 2)}%`, minWidth: '2em' }}
      >
        <span>{Math.round(value)}%</span>
      </div>
    </div>
  );
}
